/* eslint-disable no-debugger */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';
import useLscTouchpointSearchData from "@usas/ui-web/state/memberAdministration/lscTouchpoint/UseLscTouchpointData";
import useLscTouchpointsData from "../../../state/lscTouchpoints/UseLscTouchpointsData";
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

import { navLinks } from '../UseMemberAdministration';

const useLSCSTouchpoints = () => {
  const navigate = useNavigate();
  const { lscTouchpointSearchState, getLscTouchpoints } = useLscTouchpointSearchData();
  const { deleteLscTouchpoint } = useLscTouchpointsData();
  const { selectOrgUnitState } = useSelectOrgUnitData();

  const onAddClicked = () => {
    navigate(navLinks.LSC_TOUCHPOINTS_ADD, { state: { activeUserOrgUnitId: selectOrgUnitState.orgUnitId } });
  };
  
  const onEditClicked = (e, touchpoint) => {
    if (selectOrgUnitState.orgUnitId) {
      navigate(navLinks.LSC_TOUCHPOINTS_EDIT, { state: { 
        lscTouchpointId: touchpoint.lscTouchpointId,
        touchpointTypeId: touchpoint.touchpointTypeId,
        touchpointSubjectId: touchpoint.touchpointSubjectId,
        touchpointNote: touchpoint.touchpointNote,
        touchpointDate: touchpoint.touchpointDate,
        followUpDate: touchpoint.followUpDate,
        staffMemberId: touchpoint.staffMemberId,
        hasCustomerSatisfactionSurvey: touchpoint.hasCustomerSatisfactionSurvey || false
      } });
    }
  };

  function getLSCTouchpoints() {
    const getLscTouchpointPromise = getLscTouchpoints(selectOrgUnitState.orgUnitId);

    if (getLscTouchpointPromise !== null) {
      getLscTouchpointPromise.then((newState) => {
        if (newState !== null) {
          // do something with newState if needed
        }
      }).catch((e) => {
        //TODO context error
      });
    }
  }

  const onDeleteClicked = (e, usasLscTouchpointId) => {
    e?.stopPropagation();
    
    const deleteLscTouchpointPromise = deleteLscTouchpoint(usasLscTouchpointId);

    if (deleteLscTouchpointPromise !== null) {
      deleteLscTouchpointPromise.then((newState) => {
        if (newState !== null) {
          getLSCTouchpoints();
        }
      }).catch((e) => {
        //TODO context error
      });
    }
  };

  useEffect(() => {
    if (selectOrgUnitState.orgUnitId) {
      getLSCTouchpoints();
    }

  }, [selectOrgUnitState.orgUnitId]);

  return {
    lscTouchpointSearchState,
    onAddClicked,
    onEditClicked,
    onDeleteClicked
  };
}

export default useLSCSTouchpoints;